<template>
  <el-form
    :model="documentsTabForm"
    status-icon
    ref="documentsTabForm"
    @submit.native.prevent="next(contractId, 'documentsTabForm', documentsTabForm)"
  >
    <el-row :gutter="15" justify="center" type="flex">
      <el-col :span="24">
        <el-row :gutter="15" v-for="(item, index) in documentsTabForm.documents" :key="index">
          <el-col :span="14">
            <el-form-item
              :label="`Número de ${documentName(item.documentType)}`"
              :prop="`documents.${index}.number`"
            >
              <el-input
                size="small"
                v-model="item.number"
                :placeholder="item.mask"
                v-mask="item.mask"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Expedición" :prop="`documents.${index}.expedition`">
              <el-input
                size="small"
                v-model="item.expedition"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                clearable
                prefix-icon="el-icon-date"
                v-mask="'##/##/####'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Expiración" :prop="`documents.${index}.expiration`">
              <el-input
                size="small"
                v-model="item.expiration"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                clearable
                prefix-icon="el-icon-date"
                v-mask="'##/##/####'"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24" class="flex justify-end">
            <el-button size="small" @click="$emit('cancel')" v-if="showCancel">Cancelar</el-button>
            <el-button size="small" @click="$emit('back')" v-else>Atrás</el-button>
            <el-button
              size="small"
              type="primary"
              native-type="submit"
            >{{nextName != null ? nextName : 'Continuar'}}</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import axios from "axios";
import * as R from "ramda";

export default {
  name: "NewContractTabDocuments",
  props: [
    "values",
    "country",
    "contractId",
    "nextName",
    "requireConfirm",
    "showCancel"
  ],
  created() {
    axios
      .post("/", {
        query: `{ documentTypes( where: { country: ${this.country} } ) { id shortName mask required } }`
      })
      .then(res => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          this.documentTypes = data.documentTypes;
          const documents = [];
          for (const documentType of data.documentTypes) {
            const dType = this.values.find(
              v => v.documentType === documentType.id
            );
            documents.push({
              required: documentType.required,
              documentType: documentType.id,
              mask: documentType.mask,
              number: R.isNil(dType) ? null : dType.number,
              expedition: R.isNil(dType) ? null : dType.expedition,
              expiration: R.isNil(dType) ? null : dType.expiration
            });
          }
          this.documentsTabForm.documents = documents;
        }
      });
  },
  data() {
    const validateDate = (rule, value, callback) => {
      const [d, m, y] = value.split("/");
      const date = new Date(`${y}-${m}-${d}`);
      if (!dfn.isValid(date)) {
        callback(new Error("Formato de fecha incorrecto."));
        return false;
      }
      callback();
    };
    return {
      documentsTabForm: {
        documents: []
      },
      documentTypes: []
    };
  },
  methods: {
    next(contractId, formName, { documents }) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return false;
        }

        let docs = "";
        for (const d of documents) {
          delete d.mask;
          const expedition = R.isNil(d.expedition) ? null : `"${d.expedition}"`;
          const expiration = R.isNil(d.expiration) ? null : `"${d.expiration}"`;
          const number = d.number != null ? `"${d.number}"` : null;
          docs += `{
            documentType: ${d.documentType},
            expedition: ${expedition}
            expiration: ${expiration}
            number: ${number}
          }`;
        }

        if (this.requireConfirm) {
          this.$confirm(
            "¿Estás seguro que deseas actualizar estos datos?",
            "Confirmación",
            {
              confirmButtonText: "Si, actualizar",
              cancelButtonText: "Cancelar",
              type: "warning"
            }
          )
            .then(() => {
              this.proceedSave(contractId, docs, documents);
            })
            .catch((this.saving = false));
        } else {
          this.proceedSave(contractId, docs, documents);
        }
      });
    },
    proceedSave(contractId, docs, documents) {
      axios
        .post("/", {
          query: `mutation {
              employeeManageDocuments(
                where: { id: "${contractId}"},
                documents: [${docs}]
              ) { documents { expedition expiration documentType { id mask } } }
            }`
        })
        .then(res => {
          if (this.requireConfirm) {
            this.$notify({
              title: "Éxito",
              message: "Se ha actualizado la información correctamente.",
              type: "success"
            });
            this.$emit("save", true);
          } else {
            this.$message("Se ha guardado el avance.");
            this.$emit("next", { name: "documents", data: documents });
          }
        })
        .catch(console.log);
    },
    documentName(id) {
      return R.isEmpty(this.documentTypes)
        ? ""
        : this.documentTypes.find(dt => dt.id === id).shortName;
    }
  },
  mounted() {
    // this.documentsTabForm.documents = this.values;
    this.$refs["documentsTabForm"].resetFields();
  }
};
</script>
